/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

export type PanelSize = "sm" | "md" | "lg";

// Shared 12-column grid sizing vocabulary, used by both the Kiosk widget
// catalog and the main Dashboard's Server Overview grid so panel density
// reads consistently across the app.
export const SIZE_COL_SPAN: Record<PanelSize, string> = {
  sm: "col-span-12 sm:col-span-6 lg:col-span-4",
  // sm breakpoint (640px), not lg (1024px) -- an iPad in portrait (~768-834px)
  // sits between the two, so "medium" panels would otherwise stay full-width
  // until landscape.
  md: "col-span-12 sm:col-span-6",
  lg: "col-span-12",
};

export const SIZE_LABEL: Record<PanelSize, string> = {
  sm: "Small",
  md: "Medium",
  lg: "Large",
};
